module.exports = __webpack_public_path__ + "static/media/dormakaba.871c0f91.jpg";